import { useState, useEffect } from "react";

// Generated by Copilot- Start - 2026-03-23 00:00:00
/**
 * Returns window.location.href only after client mount so SSR and the first
 * client render both produce an empty string, preventing a hydration mismatch.
 * The value updates once after mount, so all data-linkDestination attributes
 * are populated correctly in the browser without causing React warnings.
 */
export const useLocationHref = () => {
  const [href, setHref] = useState("");
  useEffect(() => {
    setHref(window?.location?.href || "");
  }, []);
  return href;
};
// Generated by Copilot- End - 2026-03-23 00:00:00
